import * as React from "react";

interface Props {
  /** When filter badges are shown above the table, use a shorter placeholder height. */
  isBadgeShowing?: boolean;
}

const EmptyPendingInterventions: React.FC<Props> = ({
  isBadgeShowing = false,
}) => {
  return (
    <div
      className="loading-container"
      style={{ height: isBadgeShowing ? "45vh" : "53.8vh" }}
    >
      <h3>No pending interventions</h3>
      <p>Try adjusting your search or check back later.</p>
    </div>
  );
};

export default EmptyPendingInterventions;
